<template>
    <div>
        <p v-html="notification.message" class="darkest"></p>
        <button v-if="showInvoiceBtn" class="btn tertiary narrow mt-2" @click="viewBooking">View booking</button>
    </div>
</template>

<script>
export default {
    props:{
        notification: {
            type: Object,
        }
    },
    computed: {
        showInvoiceBtn: function () {
            if(this.notification.metadata && this.notification.metadata.bookingId){
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        viewBooking: function () {
            window.open('/reservations/view/'+this.notification.metadata.bookingId, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
    p{
        word-break: break-word;
    }
</style>



// WEBPACK FOOTER //
// bodySimple.vue?3d6dfe59